/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from 'react'
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilCheckCircle, cilWarning, cilXCircle } from '@coreui/icons'
import _ from 'lodash'
import { useSelector } from 'react-redux'

const ToastAlert = () => {
  const message = useSelector((state) => state.message)

  // useEffect(() => {
  //   if (!_.isEmpty(message))
  //     setTimeout(() => {
  //       dispatch(clearMessage())
  //     }, 5000)
  // }, [message])

  const switchIcon = (event) => {
    switch (event) {
      case 'success':
        return <CIcon icon={cilCheckCircle} size="lg" className="mr-1" />
      case 'danger':
        return <CIcon icon={cilXCircle} size="lg" className="mr-1" />
      default:
        return <CIcon icon={cilWarning} size="lg" className="mr-1" />
    }
  }
  const activeToast = (
    <CToast visible={true} color={message.event} className="text-white align-items-center">
      <div className="d-flex">
        <CToastBody>
          <h6 className="m-0 p-0">
            {switchIcon(message.event)}
            {message.title}
          </h6>
        </CToastBody>
        <CToastClose className="me-2 m-auto font-small" white />
      </div>
      <div className="m-0 p-0 border-top">
        <CToastBody>{message.message}</CToastBody>
      </div>
    </CToast>
  )
  return <>{!_.isEmpty(message.event) && <CToaster push={activeToast} placement="top-end" />}</>
}

export default memo(ToastAlert)
